import type {
    GenerateType,
    PointsComputeParams,
    PointsComputeResult,
    PointsPersonalSummaryData,
    ProjectSummaryData,
    ProjectTransactionsParams,
    ProjectTransactionsData,
    ProjectTransactionsExportParams,
    ProjectTransactionsExportData,
    RedeemPointsParams,
} from './interface';
import {request} from '@/services';

const POINTS_ENDPOINTS = {
    /** 消耗积分计算 */
    COMPUTE_CONSUME: 'proxy-aicomic/points/consume/compute',
    /** 获取个人积分概览数据 */
    PERSONAL_SUMMARY: 'proxy-aicomic/points/personal/summary',
    /** 获取项目积分概览列表 */
    PROJECT_SUMMARY: 'proxy-aicomic/points/project/summary',
    /** 获取项目积分流水 */
    PROJECT_TRANSACTIONS: 'proxy-aicomic/points/project/transactions',
    /** 导出项目积分流水明细 */
    PROJECT_TRANSACTIONS_EXPORT: 'proxy-aicomic/points/project/transactions/export',
    /** 提取积分到个人账户 */
    PROJECT_REDEEM: 'proxy-aicomic/points/project/redeem',
} as const;

/** 消耗积分计算 */
export const getPointsComputeResult = <T extends GenerateType>(data: PointsComputeParams<T>) =>
    request.post<PointsComputeResult>(POINTS_ENDPOINTS.COMPUTE_CONSUME, data);

/** 获取个人积分概览数据 */
export const getPointsPersonalSummary = () =>
    request.get<PointsPersonalSummaryData>(POINTS_ENDPOINTS.PERSONAL_SUMMARY);

/** 获取项目积分概览列表 */
export const getProjectSummary = () =>
    request.get<ProjectSummaryData>(POINTS_ENDPOINTS.PROJECT_SUMMARY);

/** 获取项目积分流水 */
export const getProjectTransactions = (params: ProjectTransactionsParams) =>
    request.get<ProjectTransactionsData>(POINTS_ENDPOINTS.PROJECT_TRANSACTIONS, {params});

/** 导出项目积分流水明细（项目维度全量） */
export const exportProjectTransactions = (params: ProjectTransactionsExportParams) =>
    request.get<ProjectTransactionsExportData>(POINTS_ENDPOINTS.PROJECT_TRANSACTIONS_EXPORT, {
        params,
    });

/** 提取积分到个人账户 */
export const redeemProjectPoints = (data: RedeemPointsParams) =>
    request.post<void>(POINTS_ENDPOINTS.PROJECT_REDEEM, data, {silent: false});
